export default __webpack_public_path__ + "static/media/Whitespace_Logo_Colour.d1bdf606.svg";